import { Component, DestroyRef, inject, OnInit, Output, EventEmitter, ViewChild, ChangeDetectorRef, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Sort } from '@angular/material/sort';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { translate } from '@jsverse/transloco';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { InstancesService } from 'src/app/services/api/instances.service';
import { ActivatedRoute } from '@angular/router';
import { TestTypes } from 'src/app/models/instance/test-types';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { CRVTService } from 'src/app/services/api/crvt.service';
import { ConfigurationState } from 'src/app/models/configurations/configuration-state';
import { UrlService } from 'src/app/services/util/url.service';
import { TenantService } from 'src/app/services/api/tenant.service';
import { CloudProvider } from 'src/app/models/cloud-provider/cloud-provider';
import { DeploymentClass } from 'src/app/models/instance-class';
import { InstanceEnvironment } from 'src/app/models/instance-environment';
import { FeatureKeys } from 'src/app/models/feature/feature-keys';
import { Feature, FeatureAttributes, FeatureDatazone } from 'src/app/models/feature/feature';
import { FeaturePermissionsService } from 'src/app/services/util/feature-permissions.service';
import { PaginatorComponent } from 'src/app/components/paginator/paginator.component';
import { Subscription } from 'rxjs';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';
import { EnvironmentPaginatorComponent } from '../environment-paginator/environment-paginator.component';
import { EnvironmentTableComponent } from '../environment-table/environment-table.component';
import { AvailabilityStatus } from 'src/app/models/availability-status';
import { toUtcString } from 'src/app/services/util/utils';

const REQUIRED_FEATURES = [
  {
    key: FeatureKeys.EF_TEST_NONPII,
    name: Feature.EF_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.SANITY_TEST_NONPII,
    name: Feature.SANITY_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.NONPII
  },
  {
    key: FeatureKeys.SANITY_TEST_PII,
    name: Feature.SANITY_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.PII
  },
  {
    key: FeatureKeys.SANITY_TEST_LIVE,
    name: Feature.SANITY_TEST,
    attribute: FeatureAttributes.DATAZONE,
    attributeValue: FeatureDatazone.LIVE
  },
];

@Component({
  selector: 'app-environment-ef-test',
  templateUrl: './environment-ef-test.component.html',
  styleUrls: ['./environment-ef-test.component.scss'],
  standalone: false,
})
export class EnvironmentEFtestComponent implements OnInit {
  @ViewChild(EnvironmentPaginatorComponent) paginatorRef: EnvironmentPaginatorComponent;
  @ViewChild(EnvironmentTableComponent) tableRef: EnvironmentTableComponent;
  
    @Output() updateInstnace = new EventEmitter();
    @Input() data: any;
    @ViewChild(PaginatorComponent, { static: true }) paginator: PaginatorComponent;
    private destroyRef = inject(DestroyRef);
    instanceId: any;
    testResultsTotal = 0;
    clientName: any;
    isAWS: boolean;
    loadDataSubscription: Subscription;
    DeploymentClass = DeploymentClass;
    pageConfigurationStates: ConfigurationState[];
    filteredConfigurationStates: ConfigurationState[];
    FeatureKeys = FeatureKeys;
    showSpinner: boolean = true;

    testResultColumns: string[] = ['testStartTime', 'testFinishTime', 'duration', 'initiatedBy', 'status', 'testResultsPath'];
    dataSourceEFTestResults: any;
    sanityTestResults: any[] = [];
    efTestResults: any[] = [];
    searchedResult = [];
    sanityPaginationSize = 10;
    EFPaginationSize = 10;
    pageIndex = 0;
    efTest = true;
    availableConfigLoaded = false;
    isSanityTestInprogress = false;
    isEFTestInprogress = false;
    featuresMap: any = {};
    showPagination: any;
    deploymentLog: any;
    sortInfo: any;
    filteredDeploymentLog: any;
    deploymentLogData: any;
    updatedLog: any;
    updatedLogData: any;
    expandedElement: null;
    dataSourceLog: any;
    filteredUpdateLog: any;
    paginationSize = 10;
    dataSourceUpdateLog: any;
    routeData: any;
    dataSource: any;
    instance: any;
    PermissionKeys = PermissionKeys;
    permissionsMap: { [key: string]: boolean; };
    showRunbook: boolean;
    isRefreshing = false;
    runbookLoading = true;
    isFiltered = false;
    efResponse = false;
    apiNotFound = false;
  showLoader = false;
  AvailabilityStatus = AvailabilityStatus;
  displayColumns = [
    {
      key: 'testStartTime',
      name: 'TEST_RESULTS.START_DATE',
      type: 'date',
      sortable: true,
      visible: true,
      disable: true,
    },
    {
      key: 'testFinishTime',
      name: 'TEST_RESULTS.END_DATE',
      type: 'date',
      visible: true,
      disable: false,
      sortable: true
    },
    {
      key: 'duration',
      name:  'TEST_RESULTS.DURATION',
      type: 'duration',
      startKey: 'testStartTime',
      endKey: 'testFinishTime',
      visible: true,
      disable: false,
      sortable: true
    },
    {
      key: 'initiatedBy',
      name: 'TEST_RESULTS.INITIATED_BY',
      type: 'userIcon',
      visible: true,
      disable: false,
      sortable: false
    },
    {
      key: 'status',
      name: 'TEST_RESULTS.STATUS',
      type: 'status',
      visible: true,
      disable: true,
      sortable: true
    },
    {
      key: 'testResultsPath',
      name: 'TEST_RESULTS.RESULT',
      type: 'result',
      sortable: false,
      visible: true,
      disable: true
    },
    {
      key: 'runbookSettings',
      name: '',
      type: 'settings',
      visible: true,
      disable: true
    }
  ];



    readonly EXCECUTETEST_ENABLE_STATES = [
        DeployStatus.DEPLOYED,
        DeployStatus.UPDATED,
        DeployStatus.UPDATE_FAILED,
        DeployStatus.CONFIGURED,
        DeployStatus.CONFIGURATION_FAILED,
        DeployStatus.TESTED,
        DeployStatus.FAILOVER_FAILED,
        DeployStatus.FAILBACK_FAILED,
        DeployStatus.PRE_FAILBACK_FAILED,
        DeployStatus.POST_FAILBACK_FAILED,
        DeployStatus.STOP_FAILED,
    ];

    constructor(
        private dialog: MatDialog, private instanceService: InstancesService, public urlService: UrlService, private route: ActivatedRoute,
        private toastrService: CustomToastrService, private crvtService: CRVTService, private tenantService: TenantService,
        private featurePermissionsService: FeaturePermissionsService, private changeDetectorRef: ChangeDetectorRef,
    ) { }

  //  MAIN FUNCTION
  ngOnInit(): void {
    this.instanceId = this.route.snapshot.params.instanceId;
    this.instance = this.data;
    this.tenantService.tenantData$.subscribe((data: any) => {
      this.isAWS = data === CloudProvider.AWS;
    });
    this.featuresMap = this.featurePermissionsService.resolveFeaturePermissions(REQUIRED_FEATURES);
     
    this.showRunbook = (this.data.deploymentClass === DeploymentClass.D && this.featuresMap[FeatureKeys.EF_TEST_NONPII])
     
    this.updateEnvironment(this.data);
    this.getTestResults(this.instanceId);
  }


  public getTestResults(id, testType?: String, page?: Number, size?: Number): void {
    this.showLoader = true;
     this.instanceService.getTestResults(id)
    .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(results => {
        this.showLoader = false;
        this.runbookLoading = false;
        this.availableConfigLoaded = true;
        this.testResultsTotal = results?.total;
        if (Number(results?.total) > 10) {
        this.instanceService.getTestResults(id, results?.total)
        .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(totalResults => { 
          this.sanityEfData(totalResults);
        },
        (error) => {
        setTimeout(() => {
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        });
      } else {
        this.availableConfigLoaded = true;
        this.sanityEfData(results);
      }
    },(error) => {
        setTimeout(() => {
          //show no data found
          if (error?.httpStatusCode === 404) {
            this.showLoader = false;
            this.sanityEfData({ data: [], total: 0 });
            return;
         }
          const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        });
  }

  /* Separate sanity & EF tests */
    sanityEfData(results): void {
    this.sanityTestResults = results.data?.filter(item =>
      item.testType === TestTypes.SANITY_TEST
    );
    if (this.sanityTestResults?.find(item => item.status === 'inprogress')) {
      this.isSanityTestInprogress = true;
    }
    this.sanityTestResults = this.sanityTestResults?.sort((a, b) => new Date(b.testStartTime).getTime() - new Date(a.testStartTime).getTime());
     this.sanityTestResults = this.sanityTestResults?.map(item => ({
      ...item,
      testStartTime: item.testStartTime ? toUtcString(item.testStartTime) : null,
      testFinishTime: item.testFinishTime ? toUtcString(item.testFinishTime) : null
    }));
    this.efTestResults = results.data?.filter(element =>
      element.testType === TestTypes.EF_TEST
    );
    if (this.efTestResults?.find(item => item.status === 'inprogress')) {
      this.isEFTestInprogress = true;
    }
    this.efTestResults = this.efTestResults?.sort((a, b) => new Date(b.testStartTime).getTime() - new Date(a.testStartTime).getTime());
     this.efTestResults = this.efTestResults?.map(item => ({
      ...item,
      testStartTime: item.testStartTime ? toUtcString(item.testStartTime) : null,
      testFinishTime: item.testFinishTime ? toUtcString(item.testFinishTime) : null
    }));
    this.efTestResults.length > 0 ? (this.efResponse=true): this.efResponse = false;

  }

    refreshClick(): void {
    this.isRefreshing = true;
    this.runbookLoading = true;
    if (this.isFiltered) {
      setTimeout(() => {
        this.isRefreshing = false;
        this.runbookLoading = false;
      }, 1000);
      return;
    }
    if (this.paginatorRef) {
      this.paginatorRef.pageIndex = 0;
    }
    this.getTestResults(this.instanceId);
    setTimeout(() => {
      this.isRefreshing = false;
      this.runbookLoading = false;
    }, 1000);
  }

  searchedItems(result): void {
    this.searchedResult = result;
    this.changeDetectorRef.detectChanges();
  }

   resetPaginator() {
    this.pageIndex = 0;
     this.paginatorRef.pageIndex = 0;
  }

  onPageChange(event) {
    this.paginationSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.tableRef?.pageChanged(event);
  }

   onTablePageChanged(event) {
    this.pageIndex = event.pageIndex;
    this.paginationSize = event.pageSize;
  }


  sortDeployData(event, filteredList?): any {
    let data;
    if(this.deploymentLog) {
    data = this.deploymentLogData;
    } else if(this.updatedLog) {
    data = this.updatedLogData;
    }
    if (filteredList) {
      data = filteredList;
    }
    return data?.sort((a, b) => {
      let comparatorResult = 0;
      switch (event.active) {
        case 'startTime':
          comparatorResult = a?.startTime && b?.startTime ? a?.startTime?.localeCompare(b?.startTime) : !a?.startTime ? -1 : 1;
          break;
        case 'finishTime':
          comparatorResult = a?.finishTime && b?.finishTime ? a?.finishTime?.localeCompare(b?.finishTime) : !a?.finishTime ? -1 : 1;
          break;
      }
      return comparatorResult * (event.direction === 'asc' ? 1 : -1);
     });
  }

   sortData(event): void {
    this.showPagination = false;
    setTimeout(() => {
      this.showPagination = true;
    }, 10);
    this.pageIndex = 0;
    if(this.deploymentLog) {
      this.sortInfo = event;
      if (this.filteredDeploymentLog?.length >= 0) {
        this.filteredDeploymentLog = this.sortDeployData(event, this.filteredDeploymentLog);
      } else {
        this.deploymentLogData = this.sortDeployData(event);
      }
      this.expandedElement = null;
      const data = this.filteredDeploymentLog ? this.filteredDeploymentLog : this.deploymentLogData;
      this.dataSourceLog = new MatTableDataSource(data?.slice(this.pageIndex, this.paginationSize));
    } else if(this.updatedLog) {
      this.sortInfo = event;
      if (this.filteredUpdateLog) {
        this.filteredUpdateLog = this.sortDeployData(event, this.filteredUpdateLog);
      } else {
        this.updatedLogData = this.sortDeployData(event);
      }
      this.expandedElement = null;
      const data = this.filteredUpdateLog ? this.filteredUpdateLog : this.updatedLogData;
      this.dataSourceUpdateLog = new MatTableDataSource(data?.slice(this.pageIndex, this.paginationSize));
    } else {
      this.dataSource = new MatTableDataSource(this.routeData?.slice(this.pageIndex, this.paginationSize));
    }
  }

  /** Download result */
  public downloadResult(data): void {
    this.crvtService
      .downloadCRVT(data.blueprintId,data.instanceId,data.id,data.testResultsPath,this.clientName,data.testType)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  }

  /** View result */
  viewTestResults(configurationState: ConfigurationState, filename: string, type?: string): void {
    this.crvtService.getViewResultsUrl( configurationState.blueprintId, configurationState.instanceId, 
        configurationState.id, filename, configurationState.tenantId, type)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((viewUrl) => {
        this.urlService.openUrlInNewTab(viewUrl);
      });
  }

  /** EF Test pagination */
  EFResultsChanged(event): any {
    if (event.length) {
      this.pageIndex = event.pageIndex;
      this.EFPaginationSize = event.pageSize;
      const firstIndex = this.pageIndex * this.EFPaginationSize;
      const data = this.efTestResults.slice(firstIndex, firstIndex + this.EFPaginationSize);
      this.dataSourceEFTestResults = new MatTableDataSource(data);
    }
  }

  /** Environment update helper */
  updateEnvironment(data) {
    switch (data.deploymentClass) {
      case DeploymentClass.D:
        this.data.environment = InstanceEnvironment.DEV;
        break;
      case DeploymentClass.C:
        this.data.environment = InstanceEnvironment.TEST;
        break;
      case DeploymentClass.B:
        this.data.environment = InstanceEnvironment.PREPROD;
        break;
      case DeploymentClass.A:
        this.data.environment = InstanceEnvironment.LIVE;
        break;
    }
  }

  public excecuteEFTest(): void {
    if (!this.isEFTestInprogress && this.EXCECUTETEST_ENABLE_STATES.includes(this.data?.status)) {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('TEST_RESULTS.EF_TEST_TITLE'),
          message: translate('TEST_RESULTS.EF_TEST_DESC'),
          confirmButtonText: translate('BUTTONS.SUBMIT')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
        if (confirm) {
          this.isEFTestInprogress = true;
          this.instanceService.putEFTest(this.instanceId)
          .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(results => {
              if (results) {
                this.getTestResults(this.instanceId, TestTypes.EF_TEST);
                this.updateInstnace.emit(this.isEFTestInprogress);
                this.instanceService.triggerRefresh();
              }
          },
          (error) => {
            const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
        this.dialog.open(ErrorDialogComponent, {
          minHeight: '342px',
          width: '630px',
          panelClass: 'flex-dialog',
          data: {
            title: translate('ERROR_DIALOG.EF_TEST_FAILED'),
            description: errorMessage
          }
        });
          });
        }
      });
    }
  }

}